module.exports = __webpack_public_path__ + "static/img/25.051fa52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/25.jpg
// module id = sk5a
// module chunks = 0